import { functional } from '@think-internet/zeus-frontend-package'
import Routes from '../../../../../redux/routes'
import { NAWSurvey } from '../../../../../types/NAW/Survey'
import { formatNumber } from '../../../../../utility'
import {
  getErsparnisPercentage,
  getJaehrlicheErsparnis,
  getNeueBueroflaeche,
  getRecommendedDeskSharingQuote,
  getTables,
} from '../Summary/calculation'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { useState } from 'react'

type GetResultExport = () => Promise<void>

type Return = GetResultExport

const useGetResultExport = (data: NAWSurvey): [Return, boolean] => {
  const submit = functional.use(Routes.DOWNLOAD_NAW_RESULT)
  const t = useSelector((s) => s[props.TRANSLATION])
  const [isLoading, setIsLoading] = useState(false)

  const getResultExport: GetResultExport = async () => {
    setIsLoading(true)
    const resultLink = await submit({
      data: {
        ...data,
        flaecheIst: formatNumber(data.flaecheIst),
        deskSharingPercentage: data.deskSharingPercentage === 1 ? '1,0' : formatNumber(data.deskSharingPercentage),
      },
      result: {
        neueFlaeche: `${formatNumber(getNeueBueroflaeche(data))}${t.generic.squareMeterSuffix}`,
        ersparnisPercentag: `${getErsparnisPercentage(data)}${t.generic.percentageSuffix}`,
        jaehrlicheErsparnis: `${formatNumber(getJaehrlicheErsparnis(data))}${t.generic.euroSuffix}`,
        recommendedDeskSharingPercentage: getRecommendedDeskSharingQuote(data) === 1 ? '1,0' : formatNumber(getRecommendedDeskSharingQuote(data)),
        recommendedDeskSharingTables: formatNumber(getTables(data, getRecommendedDeskSharingQuote(data))),
        deskSharingTables: formatNumber(getTables(data)),
      },
    })
    setIsLoading(false)

    const newTab = window.open(resultLink, '_blank', 'noopener,noreferrer')
    if (!newTab) {
      window.location.href = resultLink
    }
  }

  return [getResultExport, isLoading]
}

export default useGetResultExport
